import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import type { FC } from "react";
import OrderNotes from "./OrderNotes";

interface Props {
  readonly orderId: string;
  readonly contactDate: string | undefined;
}

const ExpandableOrderNotes: FC<Props> = ({ orderId, contactDate }) => {
  return (
    <Accordion defaultExpanded slotProps={{ transition: { unmountOnExit: true, mountOnEnter: true } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6">Notatki</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <OrderNotes orderId={orderId} contactDate={contactDate} />
      </AccordionDetails>
    </Accordion>
  );
};

export default ExpandableOrderNotes;
